module.exports = __webpack_public_path__ + "static/media/cart-shopping-solid-dark.ce888e36.png";